export interface PrintSize {
  id: string;
  name: string;
  dimensions: string;
  price: number;
  recommended?: boolean;
  printType: 'canvas' | 'aluDibond';
}

export interface CartItem {
  id: string; // Unique cart item ID
  imageId: string;
  imageSrc: string;
  imageTitle: string;
  size: PrintSize;
  quantity: number;
  price: number; // Total price for this item (size.price * quantity)
  addedAt: Date;
}

export interface Order {
  id: string;
  items: CartItem[];
  totalAmount: number;
  customerInfo: {
    name: string;
    email: string;
    phone: string;
    address: string;
    notes?: string;
  };
  status: 'pending' | 'confirmed' | 'processing' | 'shipped' | 'delivered';
  createdAt: Date;
  updatedAt: Date;
}

// Available print sizes and prices (matching pricing.json)
export const PRINT_SIZES: PrintSize[] = [
  // Canvas Prints
  { id: 'canvas-20x30', name: '20×30 cm', dimensions: '20cm × 30cm', price: 30, recommended: false, printType: 'canvas' },
  { id: 'canvas-30x30', name: '30×30 cm', dimensions: '30cm × 30cm', price: 44, recommended: false, printType: 'canvas' },
  { id: 'canvas-30x40', name: '30×40 cm', dimensions: '30cm × 40cm', price: 56, recommended: false, printType: 'canvas' },
  { id: 'canvas-40x60', name: '40×60 cm', dimensions: '40cm × 60cm', price: 63, recommended: true, printType: 'canvas' },
  { id: 'canvas-50x70', name: '50×70 cm', dimensions: '50cm × 70cm', price: 82, recommended: false, printType: 'canvas' },
  { id: 'canvas-60x90', name: '60×90 cm', dimensions: '60cm × 90cm', price: 102, recommended: false, printType: 'canvas' },
  // Alu-Dibond Prints
  { id: 'alu-a3', name: 'A3 Alu', dimensions: 'A3 (297 × 420mm)', price: 61, recommended: false, printType: 'aluDibond' },
  { id: 'alu-a2', name: 'A2 Alu', dimensions: 'A2 (420 × 594mm)', price: 83, recommended: false, printType: 'aluDibond' },
  { id: 'alu-a1', name: 'A1 Alu', dimensions: 'A1 (594 × 841mm)', price: 140, recommended: false, printType: 'aluDibond' },
];

export interface CartState {
  items: CartItem[];
  totalItems: number;
  totalAmount: number;
}